import MainLayout from "@/components/layout/admin/MainLayout.vue";
// import Pagination from "laravel-vue-pagination";
import RegionJson from "@/assets/json/region.json";
import axios from "axios";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';

export default {
    name: "jobList",
    components: {
        MainLayout,
        // Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            jobList: {},
            category: [],
            keyword: {
                job_title: "",
                category_name: "",
                region: ""
            },
            page_status: false,
            regionArr: RegionJson
        };
    },

    methods: {
        getJob(page = 1) {
            axios.get("/job/list?page=" + page)
                .then(response => {
                    this.jobList = response.data;
                })
                .catch(error => {
                    console.log("Job List API Error", error);
                });
        },

        getCategoryForJob() {
            axios.get("/job/category/list")
                .then(response => {
                    this.category = response.data;
                })
                .catch(error => {
                    console.log("Category List API Error", error);
                })
        },

        searchJob(page = 1) {
            var request = {
                params: {
                    keyword: this.keyword.job_title,
                    keyword1: this.keyword.category_name,
                    keyword2: this.keyword.region
                }
            }
            axios.get("/job/search/result?page="+page, request)
                .then(response => {
                    this.page_status = true;
                    this.jobList = response.data;
                })
                .catch(error => {
                    console.log("Job Search API Error", error);
                });
        },

        confirmDelete(id) {
            if (window.confirm("Are you sure?")) {
                this.deleteJob(id);
            } else {
                console.log("no");
            }
        },

        deleteJob(id) {
            axios.delete("/job/delete/" + id)
                .then(response => {
                    this.jobList = response.data;
                    this.getJob()
                })
                .catch(error => {
                    console.log("Job Delete Error->", error.response.data);
                })
        },
    },

    mounted() {
        this.getJob();
        this.getCategoryForJob();
    }
};